import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const FilledSunrise: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_sunrise"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="sunrise icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M5.66247 11C5.59147 10.6832 5.554 10.3538 5.554 10.0156C5.554 7.54052 7.56042 5.5341 10.0355 5.5341C12.5105 5.5341 14.5169 7.54052 14.5169 10.0156C14.5169 10.3538 14.4794 10.6832 14.4084 11H17.5C17.7761 11 18 11.2239 18 11.5C18 11.7761 17.7761 12 17.5 12H2.5C2.22386 12 2 11.7761 2 11.5C2 11.2239 2.22386 11 2.5 11H5.66247ZM10.135 18C10.0996 18.0079 10.0629 18.0121 10.0251 18.0121C9.98738 18.0121 9.95062 18.0079 9.91526 18H10.135ZM5.07621 4.38153L5.00696 4.32367C4.81209 4.18867 4.54267 4.20796 4.3691 4.38153C4.17384 4.57679 4.17384 4.89337 4.3691 5.08863L5.22742 5.94695L5.29667 6.0048C5.49153 6.1398 5.76096 6.12051 5.93452 5.94695C6.12979 5.75168 6.12979 5.4351 5.93452 5.23984L5.07621 4.38153ZM15.7386 5.01938C15.8736 4.82452 15.8543 4.55509 15.6808 4.38153C15.4855 4.18626 15.1689 4.18626 14.9736 4.38153L14.1153 5.23984L14.0575 5.30909C13.9225 5.50396 13.9418 5.77338 14.1153 5.94695C14.3106 6.14221 14.6272 6.14221 14.8224 5.94695L15.6808 5.08863L15.7386 5.01938ZM10.5204 2.43454C10.478 2.20129 10.2739 2.02441 10.0284 2.02441C9.75227 2.02441 9.52841 2.24827 9.52841 2.52441V3.73825L9.53647 3.82813C9.57881 4.06138 9.78295 4.23825 10.0284 4.23825C10.3046 4.23825 10.5284 4.0144 10.5284 3.73825V2.52441L10.5204 2.43454ZM8.5 16C8.22386 16 8 16.2239 8 16.5C8 16.7761 8.22386 17 8.5 17H11.5C11.7761 17 12 16.7761 12 16.5C12 16.2239 11.7761 16 11.5 16H8.5ZM5 14C5 13.7239 5.22386 13.5 5.5 13.5H14.5C14.7761 13.5 15 13.7239 15 14C15 14.2761 14.7761 14.5 14.5 14.5H5.5C5.22386 14.5 5 14.2761 5 14Z" />
      </svg>
    </span>
  );
};

export { FilledSunrise };
